export const environment = {
  production: true,
  buildId: '3674680451123111',
  configFile: 'config.json',
};
